import { lazy } from "react";

export const UpdatePatientAsync = lazy(() => import("./UpdatePatient"));
